import { defineComponent as _defineComponent } from 'vue'
import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col mt-4 gap-6" }
const _hoisted_2 = { class: "flex justify-center" }

import { ref, computed } from 'vue';
import { useSelfServicePhysicalMembershipCardStore, useAccountStore } from '@/store';
import { RichText } from '@sitecore-jss/sitecore-jss-vue';
import { LONG_MONTH_DATE } from '@/constants/formats';
import { format } from 'date-fns';
import { replaceBookmark } from '@/utils/bookmark.replace';
import InformationBox from '../InformationBox/InformationBox.vue';
import { InformationBoxTypes } from '@/interfaces/forms/information-box.interface';
import PanelTitle from '../PanelTitle/PanelTitle.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'AlreadyOrdered',
  props: {
    membershipCardModal: {}
  },
  emits: ['closeChildModal'],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const accountStore = useAccountStore();
const physicalCardStore = useSelfServicePhysicalMembershipCardStore();

const showModal = ref(false);
__expose({ showModal: () => (showModal.value = true), hideModal: () => (showModal.value = false) });

const emit = __emit;

const props = __props;

const alreadyOrderedInfoBoxContent = computed(() => {
  physicalCardStore.calcExpectedDeliveryDate(accountStore.identityDetails?.membershipCardRequestedDate);

  const content = props.membershipCardModal.fields.alreadyOrderedInfoBox?.fields?.content?.value;
  let value = replaceBookmark(
    'estimatedArrival',
    content ?? '',
    format(physicalCardStore.expectedArrivalDate ?? new Date(), LONG_MONTH_DATE)
  );

  const postalAddress = accountStore.identityDetails?.addresses?.find(
    (item) => item.addressType?.toLowerCase() == 'postal'
  );

  value = replaceBookmark('addressLine1', value, postalAddress?.formattedLong ?? '');
  value = replaceBookmark('addressLine2', value, '');

  return value;
});

const onClose = () => {
  emit('closeChildModal');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(PanelTitle, _normalizeProps(_guardReactiveProps(_ctx.membershipCardModal.fields.alreadyOrderedTitle)), null, 16)
    ]),
    _createElementVNode("div", null, [
      _createVNode(InformationBox, {
        title: _ctx.membershipCardModal.fields.alreadyOrderedInfoBox?.fields?.title?.value,
        description: alreadyOrderedInfoBoxContent.value,
        type: _unref(InformationBoxTypes).WARNING,
        isCircle: false,
        useButtonSlot: false
      }, null, 8, ["title", "description", "type"])
    ]),
    _createElementVNode("div", null, [
      _createVNode(_unref(RichText), {
        field: _ctx.membershipCardModal.fields?.alreadyOrderedText
      }, null, 8, ["field"])
    ]),
    _createElementVNode("div", { class: "flex flex-col" }, [
      _createElementVNode("button", {
        class: "btn btn-secondary btn-md",
        onClick: onClose
      }, "Close")
    ])
  ]))
}
}

})